import { createSelector } from 'reselect';

export const selectTransportVouchersSlice = state => state.transportVouchers;

export const selectTransportVouchers = createSelector(
  selectTransportVouchersSlice,
  slice => slice.transportVouchers
);
export const transportVouchersLoaded = createSelector(
  selectTransportVouchersSlice,
  slice => slice.transportVouchersLoaded
);
export const selectActiveTransportVoucher = createSelector(
  selectTransportVouchersSlice,
  slice => slice.activeTransportVoucher
);

export const transportVouchersMeta = createSelector(
  selectTransportVouchersSlice,
  slice => slice.meta
);
export const transportVouchersFilters = createSelector(
  selectTransportVouchersSlice,
  slice => slice.filters
);

export const transportVouchersCreating = createSelector(
  selectTransportVouchersSlice,
  slice => slice.isCreating
);
export const transportVouchersUpdating = createSelector(
  selectTransportVouchersSlice,
  slice => slice.isUpdating
);
export const transportVouchersDeleting = createSelector(
  selectTransportVouchersSlice,
  slice => slice.isDeleting
);
export const transportVouchersErrors = createSelector(
  selectTransportVouchersSlice,
  slice => slice.errors
);
